import { render, staticRenderFns } from "./OrcidBulkAssignment.vue?vue&type=template&id=64640a88&"
import script from "./OrcidBulkAssignment.vue?vue&type=script&lang=js&"
export * from "./OrcidBulkAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/usage/OrcidBulkAssignment.vue
// module id = 1400
// module chunks = 0